import { render, staticRenderFns } from "./whatapp-chat-user.vue?vue&type=template&id=35523680&scoped=true&"
import script from "./whatapp-chat-user.vue?vue&type=script&lang=js&"
export * from "./whatapp-chat-user.vue?vue&type=script&lang=js&"
import style0 from "./whatapp-chat-user.vue?vue&type=style&index=0&id=35523680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35523680",
  null
  
)

export default component.exports